import Frame1 from "../../assets/photobooth/frame-1.png";
import Frame2 from "../../assets/photobooth/frame-2.png";
import Frame3 from "../../assets/photobooth/frame-3.png";
import Frame1BG from "../../assets/photobooth/frame-1-bg.png";
import Frame2BG from "../../assets/photobooth/frame-2-bg.png";
import Frame3BG from "../../assets/photobooth/frame-3-bg.png";
import React, {memo, useCallback} from "react";

const FrameSelect = ({display, onFrameSelect}) => {

    const handleFrameClick = useCallback(frame => {
        onFrameSelect(frame)
    }, [])

    return (<div style={{display: display ? 'inherit' : 'none'}}>
        <img src={Frame1} alt="Frame 1" className="frame-img"
             onClick={() => handleFrameClick(Frame1BG)}/>
        <img src={Frame2} alt="Frame 2" className="frame-img"
             onClick={() => handleFrameClick(Frame2BG)}/>
        <img src={Frame3} alt="Frame 3" className="frame-img"
             onClick={() => handleFrameClick(Frame3BG)}/>
    </div>);
}

export default memo(FrameSelect)